module.exports = __webpack_public_path__ + "img/bikkurapon_target.77ac35ae.png";